<template>
    <div class="card mt-3 bg-statusWarning">
        <div class="card-body">
            <div class="row mb-2">
                <div class="col">
                    <span class="mb-0 pb-0" data-test-hook="payment-account-needs-attention">
                        <i class="far fa-triangle-exclamation pr-2"
                            data-test-hook="payment-account-needs-attention-icon" />
                        <span style="font-size:1rem; font-weight: bold;"
                            data-test-hook="payment-account-needs-attention-text">{{
                            $t('xYourAccountNeedsAttentionHeader') }}</span>
                    </span>
                </div>
            </div>
            <div class="row mb-2 ml-2">
                <div class="col">
                    <span data-test-hook="payment-method-issue-header-text">
                        {{
                            $t('xPaymentMethodIssuePleaseUpdateOrPlanWillBeCanceled', {
                                date: $moment(dunningSubscription?.subscriptionDunningDate).format($t('xShortDate'))
                            })
                        }}
                    </span>
                </div>
            </div>
            <div class="row ml-2">
                <div class="col">
                    <span v-if="isSubOnAppleStore"
                        data-test-hook="apple-payment-method-issue-body-text">
                        {{ $t('xPlanOnAppleUpdateYourPaymentMethod') }}
                    </span>
                    <span v-else-if="isSubOnGoogleStore"
                        data-test-hook="google-payment-method-issue-body-text">
                        {{ $t('xPlanOnGoogleUpdateYourPaymentMethod') }}
                    </span>
                    <button v-else type="button" class="btn btn-warning btn-update"
                        @click="openPaymentInformation()" data-test-hook="web-payment-method-issue-button">
                        {{ $t('xUpdatePaymentInformation') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import * as Constants from '@/constants'

/**
 * The DunningSubscriptionBanner shows on the SubscriptionSettings details page when there is an subscription that is
 * in grace period or there is a legacy subscription that is dunning.
 */
export default {
    name: 'DunningSubscriptionBanner',
    props: ['dunningSubscription'],
    computed: {
        isSubOnAppleStore() {
            return this.dunningSubscription?.subscriptionStore === Constants.AppleSubscriptionStore
        },
        isSubOnGoogleStore() {
            return this.dunningSubscription?.subscriptionStore === Constants.GoogleSubscriptionStore
        },
    },
    methods: {
        openPaymentInformation() {
            this.$router.push({ name: 'paymentInformation' })
        }
    }
}
</script>

<style scoped>
.btn-update {
    background-color: var(--carbon-900) !important;
}
.btn-update:hover {
    background-color: var(--carbon-800) !important;
}
.btn-update:pressed {
    background-color: var(--black) !important;
}
</style>

